module.exports = {
	// clientType : 12,
	clientType: (function () {
		const ua = window.navigator.userAgent;
		let type = 12;
		if (
			window.__wxjs_environment === "miniprogram" ||
			/miniProgram/gi.test(ua)
		) {
			return 20;
		} else if (/MicroMessenger/gi.test(ua)) {
			return 123;
		}
		return type;
	})(),
	domain: "//passport.huize.com",
	apiPrefix: "/api",
};



// WEBPACK FOOTER //
// ./src/config/touch/development.js